/**
 * 登录失败分流：外层会拼系统前缀，用包含判断，不要全等。
 */

export function getErrorMsg(error: any): string {
  if (!error) {
    return '';
  }
  if (typeof error === 'string') {
    return error;
  }
  if (error.error && typeof error.error.msg === 'string') {
    return error.error.msg;
  }
  if (typeof error.msg === 'string') {
    return error.msg;
  }
  if (typeof error.message === 'string') {
    return error.message;
  }
  return '';
}

export function msgIncludes(msg: any, snippet: string): boolean {
  return typeof msg === 'string' && msg.indexOf(snippet) > -1;
}

/** 短票没有 / 过期 / 已用；或只有 companyId */
export function isCompanySelectionExpired(msg: any): boolean {
  return msgIncludes(msg, '登录验证已失效，请重新验证');
}

/** 点选的公司不在白名单；短票仍可用 */
export function isCompanyAccountInvalid(msg: any): boolean {
  return msgIncludes(msg, '该公司账号已失效');
}

export function isCaptchaExpired(msg: any): boolean {
  return msgIncludes(msg, '验证码已失效');
}

export function isCaptchaWrong(msg: any): boolean {
  return msgIncludes(msg, '图像验证码错误');
}

/** 有正式 token 才算已登录；null / 省略 / 空字符串都当未登录 */
export function hasFormalLoginToken(data: any): boolean {
  return !!(data && data.token);
}



// WEBPACK FOOTER //
// ./src/app/login-error.util.ts